import React, { ReactNode } from 'react';

export const defaultDivider = (
  <div className='flex-shrink-0 h-[32px] border-r border-stroke' />
);

export const insertDivider = (
  elements: ReactNode[],
  options?: {
    divider?: ReactNode;
    fromFirst?: boolean;
  },
) => {
  const { divider = defaultDivider, fromFirst } = options || {};
  return elements.filter(Boolean).map((element, index, list) => {
    const isFirst = index === 0;
    const isLast = index === list.length - 1;

    return (
      <React.Fragment key={'dividerWrapper' + index}>
        {fromFirst && isFirst && list.length > 1 && divider}
        {element}
        {isLast ? null : divider}
      </React.Fragment>
    );
  });
};
